import { Box, styled } from "@mui/material";

const Column = styled(Box)({
  width: "100%",
});

export default Column;
